import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import XLSX from "xlsx";
import {array} from "prop-types";

class ScoreExport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataExport   : [],
            dataAnalisa   : [],
            dataExportNilai: [],
            isLoading: false,
            isLoadingAnalisa: false,
            isButtonLoading: false,
            examId:"",
            participant_id:"",
            jumNilai:'',
            kelasNama:'',
            ujianNama:''
        };

        this.exportFile = this.exportFile.bind(this);

    }

    loadExport() {
        this.setState({ isButtonLoading: true });

        const params = qs.stringify({
            exam_id:this.props.match.params.exam_id,
            participant_id:this.props.match.params.participant_id
        });

        axios({
            method: "post",
            url: "ujian/siswanilai?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.success) {
                    this.setState({
                        dataExport: result.data[0],
                        kelasNama: result.data[0].kelas.kelas_nama,
                        dataExportNilai: result.data[0].nilai,
                        ujianNama: result.data[0].exam_title,
                        jumNilai:result.data[0].length,
                        isButtonLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isButtonLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadAnalisa() {
        this.setState({ isButtonLoading: true, isLoadingAnalisa: true });

        const params = qs.stringify({
            exam_id:this.props.match.params.exam_id,
            participant_id:this.props.match.params.participant_id
        });

        axios({
            method: "post",
            url: "ujian/nilaianalisa?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.success) {
                    this.setState({
                        dataAnalisa: result.data,
                        isLoadingAnalisa: false,
                        isButtonLoading: false,
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isButtonLoading: false, isLoadingAnalisa: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false, isLoadingAnalisa: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    exportFile() {
        this.setState({ isButtonLoading: true });
        /*const wb = XLSX.utils.book_new()

        let presensi = [];
        let sheet1 = [];

        presensi = [["Guru",this.state.dataExport.user_nama]]
        presensi.push(["Mata Pelajaran",this.state.dataExport.mapel_nama])
        presensi.push(["Tanggal Ujian",this.state.dataExport.exam_start_date])
        presensi.push(["Waktu Ujian (menit)",this.state.dataExport.exam_end_date])
        presensi.push(["Judul Ujian",this.state.dataExport.exam_title])
        presensi.push([""])
        presensi.push(["No","NAMA", "KELAS", "TOTAL SOAL","TOTAL JAWAB","TOTAL NILAI","NILAI SISWA","STATUS"])

        this.state.dataExportNilai.map((it,o) => {
            presensi.push([
                o+1,
                it.user_nama,
                this.state.kelasNama,
                it.en_tot_soal,
                it.en_tot_jawab,
                it.en_tot_nilai,
                Math.round(it.en_nilai),
                it.en_tot_jawab > 0 ? 'Finish' : 'Belum Ujian'
            ])
        })

        let lembar = [];
        this.state.dataExportNilai.map((it) => {
            let rat = 0;
            rat = it.en_nilai !== 0 ? it.en_nilai/it.en_tot_soal : '0';

            lembar.push(
                [['Nama:'],[it.user_nama]],
                [['Kelas:'],[this.state.kelasNama]],
                [['Mata Pelajaran:'],[this.state.dataExport.mapel_nama]],
                [['Waktu Ujian (menit):'],[this.state.dataExport.exam_time_limit]],
                [['Judul Ujian:'],[this.state.dataExport.exam_title]],
                [['Nilai Siswa:'],[it.en_nilai]],
                [['Nilai Rata-Rata:'],[Math.round(rat)]],
                [""],
                [[""],["Dikerjakan"]],
                [["No."],["Soal"]],
            );

            it.detJwb.map((item, i)=>{
                if(item.question_type !== 'essay'){
                    lembar.push(
                        [[i+1],[item.question_text]],
                        [[''],['Jawaban Siswa'],[item.end_jawab_alias]],
                        [[''],['Jawaban Benar'],[item.end_benar_alias]],
                        ['']
                    );
                }else{
                    lembar.push(
                        [[i+1],[item.question_text]],
                        [[''],['Jawaban Siswa'],[item.end_jawab_alias]],
                        [[''],['Jawaban Koreksi'],[item.end_jawab_koreksi]],
                        ['']
                    );
                }

            })

            lembar.push(
                [[""],["Tidak Dikerjakan"]],
                [["No."],["Soal"]],
            );

            it.notJwb.map((item, i)=>{
                if(item.question_type !== 'essay'){
                    lembar.push(
                        [[i+1],[item.question_text]],
                        [[''],['Jawaban Siswa'],['-']],
                        [[''],['Jawaban Benar'],['-']],
                        ['']
                    );
                }else{
                    lembar.push(
                        [[i+1],[item.question_text]],
                        [[''],['Jawaban Siswa'],['-']],
                        [[''],['Jawaban Koreksi'],['-']],
                        ['']
                    );
                }

            })

        });


        sheet1 = [XLSX.utils.aoa_to_sheet(presensi), XLSX.utils.aoa_to_sheet(lembar)]
        XLSX.utils.book_append_sheet(wb, sheet1[0], 'Nilai Ujian')
        XLSX.utils.book_append_sheet(wb, sheet1[1], 'Lembar Ujian')
        XLSX.writeFile(wb, "Rekap Nilai-"+ this.state.kelasNama+"-"+ this.state.ujianNama +".xlsx")
        */
        const wb = XLSX.utils.book_new()
        const sheet1 = XLSX.utils.table_to_sheet(document.getElementById('table-to-xls'), {sheet:"Nilai Ujian"});
        const sheet2 = XLSX.utils.table_to_sheet(document.getElementById('table-to-xls2'), {sheet:"Lembar Ujian"});
        const sheet3 = XLSX.utils.table_to_sheet(document.getElementById('table-to-xls3'), {sheet:"Analisa Ujian"});
        XLSX.utils.book_append_sheet(wb, sheet1, 'Nilai Ujian')
        XLSX.utils.book_append_sheet(wb, sheet2, 'Lembar Ujian')
        XLSX.utils.book_append_sheet(wb, sheet3, 'Analisa Ujian')
        XLSX.writeFile(wb, "Rekap Nilai-"+ this.state.kelasNama+"-"+ this.state.ujianNama +".xlsx")


        this.setState({ isButtonLoading: false });
    }

    componentDidMount() {
        this.loadExport();
        this.loadAnalisa();
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">Nilai Ujian
                                {/*<button
                                    className="btn btn-primary"
                                    style={{ marginTop:'30px' }}
                                    onClick={this.exportFile}>
                                    <i className=" fa fa-download"></i>
                                    <ReactHTMLTableToExcel
                                        id="test-table-xls-button"
                                        className="download-table-xls-button pull-right"
                                        table="table-to-xls"
                                        filename={this.state.dataExport.exam_title+"_"+this.state.kelasNama}
                                        sheet="Nilai ujian"
                                        buttonText={"Download File"}
                                    />
                                </button>*/}
                                {/*<button

                                    className="btn btn-primary btn-sm float-right"
                                    disabled={this.state.isButtonLoading && "disabled" || this.state.dataExport.length === 0 && "disabled"}
                                    onClick={this.exportFile}>
                                    {this.state.isButtonLoading || this.state.dataExportNilai.length === 0 ? "Menyiapkan file..." : "Export Nilai"}
                                </button>*/}
                            </div>
                            <div className="card-block">
                                {
                                    this.state.isLoading || this.state.isButtonLoading ||  this.state.dataExportNilai.length === 0 ? (
                                        <div style={{ textAlign:'center' }}>
                                            <div className="loader" style={{
                                                borderLeft: '15px solid #20a8d8'
                                            }}></div>
                                            File Sedang disiapkan, Mohon menunggu..
                                        </div>
                                    ) : this.state.dataExportNilai.length === 0 ? (
                                        <div style={{ textAlign:'center' }}>
                                            Data nilai kosong, pastikan anda sudah generate nilai pada halaman sebelumnya
                                        </div>
                                    ) : (
                                        <div>
                                            <div style={{ display:'none' }} className="card">
                                                <table className="table table-striped table-bordered animated fadeIn" style={{ display:'none' }} id="table-to-xls">
                                                    <tbody>
                                                    <tr>
                                                        <td>Guru</td>
                                                        <td colSpan="7">{this.state.dataExport.user_nama}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Mapel</td>
                                                        <td colSpan="7">{this.state.dataExport.mapel_nama}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Judul</td>
                                                        <td colSpan="7">{this.state.dataExport.exam_title}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Kelas</td>
                                                        <td colSpan="7">{this.state.kelasNama}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Tanggal</td>
                                                        <td colSpan="7">{this.state.dataExport.exam_start_date+' Sampai '+this.state.dataExport.exam_end_date}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="8"></td>
                                                    </tr>
                                                    <tr>
                                                        <th rowSpan="2"></th>
                                                        <th rowSpan="2">NAMA</th>
                                                        <th rowSpan="2">KELAS</th>
                                                        <th rowSpan="2">NISN/NIS</th>
                                                        <th colSpan="6">TOTAL</th>
                                                        <th colSpan="2">PILIHAN GANDA</th>
                                                        <th></th>
                                                        <th>KETERANGAN</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Soal</td>
                                                        <td>Nilai</td>
                                                        <td>PG</td>
                                                        <td>Essay</td>
                                                        <td>Jawab</td>
                                                        <td>Tidak Jawab</td>
                                                        <td>Jawaban Benar</td>
                                                        <td>Jawaban salah</td>
                                                        <td>Nilai Akhir</td>
                                                        <td></td>
                                                    </tr>
                                                    {
                                                        this.state.dataExportNilai.map((items,i) => {
                                                            return (
                                                                <tr key={items.user_id}>
                                                                    <td>{i+1}</td>
                                                                    <td>{items.user_nama}</td>
                                                                    <td>{this.state.kelasNama}</td>
                                                                    <td>{items.siswa_nisn != "null"||items.siswa_nisn != ""||!items.siswa_nisn?items.siswa_nisn:items.siswa_nis}</td>
                                                                    <td>{items.en_tot_soal}</td>
                                                                    <td>{items.en_tot_nilai}</td>
                                                                    <td>0</td>
                                                                    <td>0</td>
                                                                    <td>{items.en_tot_jawab}</td>
                                                                    <td>{items.cNot}</td>
                                                                    <td>{items.cBenar}</td>
                                                                    <td>{items.cSalah}</td>
                                                                    <td>{Math.round(items.en_nilai)}</td>
                                                                    <td>
                                                                        <button
                                                                            type="button"
                                                                            className={`btn btn-sm ${
                                                                                items.en_tot_jawab > 0
                                                                                    ? "btn-primary"
                                                                                    : "btn-warning"
                                                                            }`}

                                                                        >
                                                                            {items.en_tot_jawab > 0 ? 'Finish' : 'Belum Ujian'}
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style={{ display:'none' }} className="card">
                                                <table className="table table-striped table-bordered animated fadeIn" style={{ display:'none' }} id="table-to-xls2">
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan="8">{this.state.dataExport.exam_title}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="8">{localStorage.SECOLAH_NAME}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="8"></td>
                                                    </tr>
                                                    </tbody>

                                                    {
                                                        this.state.dataExportNilai.map((item, p)=>{
                                                            let rat = 0;
                                                            rat = item.en_nilai !== 0 ? item.en_nilai/item.en_tot_soal : '0';
                                                            return(
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan="2">Nama Siswa</td>
                                                                        <td colSpan="2">{ item.user_nama }</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="2">Kelas</td>
                                                                        <td colSpan="2">{ this.state.kelasNama }</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="2">Mapel</td>
                                                                        <td colSpan="2">{ this.state.dataExport.mapel_nama }</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="2">Waktu (Menit)</td>
                                                                        <td colSpan="2">{ this.state.dataExport.exam_time_limit }</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="2">Nilai Siswa</td>
                                                                        <td colSpan="2">{ item.en_nilai }</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="2">Rata-Rata</td>
                                                                        <td colSpan="2">{ Math.round(rat) }</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="4"></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="4">Soal Dijawab</td>
                                                                    </tr>
                                                                        {
                                                                            item.detJwb.length > 0 ? (
                                                                                item.detJwb.map((jwb, s)=>{
                                                                                return(
                                                                                   <tbody>
                                                                                        <tr>
                                                                                           <td>{s+1}</td>
                                                                                           <td colSpan="4">{jwb.question_text}</td>
                                                                                       </tr>
                                                                                        {
                                                                                            jwb.question_type !== 'essay' ? (
                                                                                                <tbody>
                                                                                                <tr>
                                                                                                    <td></td>
                                                                                                    <td colSpan="2">Jawaban Siswa</td>
                                                                                                    <td>{jwb.end_jawab_alias}</td>
                                                                                                </tr>
                                                                                                <tr>
                                                                                                    <td></td>
                                                                                                    <td colSpan="2">Jawaban Benar</td>
                                                                                                    <td>{jwb.end_benar_alias}</td>
                                                                                                </tr>
                                                                                                </tbody>
                                                                                            ) : (
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td></td>
                                                                                                        <td colSpan="2">Jawaban Siswa</td>
                                                                                                        <td>{jwb.end_jawab_alias}</td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td></td>
                                                                                                        <td colSpan="2">Jawaban Koreksi</td>
                                                                                                        <td>{jwb.end_jawab_koreksi}</td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            )
                                                                                        }

                                                                                   </tbody>
                                                                                )
                                                                            })
                                                                            ) : <td>Jawaban Kosong</td>
                                                                        }
                                                                    <tr>
                                                                        <td colSpan="4">Soal Tidak Dijawab</td>
                                                                    </tr>
                                                                        {
                                                                            item.notJwb.length > 0 ? (
                                                                                item.notJwb.map((jwb, s)=>{
                                                                                return(
                                                                                    <tbody>
                                                                                    <tr>
                                                                                        <td>{s+1}</td>
                                                                                        <td colSpan="4">{jwb.question_text}</td>
                                                                                    </tr>
                                                                                    {
                                                                                        jwb.question_type !== 'essay' ? (
                                                                                            <tbody>
                                                                                            <tr>
                                                                                                <td></td>
                                                                                                <td colSpan="2">Jawaban Siswa</td>
                                                                                                <td>-</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td></td>
                                                                                                <td colSpan="2">Jawaban Benar</td>
                                                                                                <td>-</td>
                                                                                            </tr>
                                                                                            </tbody>
                                                                                        ) : (
                                                                                            <tbody>
                                                                                            <tr>
                                                                                                <td></td>
                                                                                                <td colSpan="2">Jawaban Siswa</td>
                                                                                                <td>-</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td></td>
                                                                                                <td colSpan="2">Jawaban Koreksi</td>
                                                                                                <td>-</td>
                                                                                            </tr>
                                                                                            </tbody>
                                                                                        )
                                                                                    }

                                                                                    </tbody>
                                                                                )
                                                                            })
                                                                            ):<td>Semua Soal Dijawab</td>
                                                                        }
                                                                    <tr>
                                                                        <td colSpan="4"></td>
                                                                    </tr>
                                                                </tbody>
                                                            )
                                                        })
                                                    }

                                                </table>
                                            </div>

                                            {
                                                this.state.isLoading || this.state.isButtonLoading ||  this.state.dataAnalisa.length === 0 ? (
                                                    <div style={{ textAlign:'center' }}>
                                                        {
                                                            this.state.isLoadingAnalisa ? (
                                                                <div>
                                                                    <div className="loader" style={{
                                                                        borderLeft: '15px solid #20a8d8'
                                                                    }}></div>
                                                                    Data Analisa nilai Sedang disiapkan, Mohon menunggu..
                                                                    <br/>
                                                                    Anda tetap dapat mengunduh file nilai dan lembar jawaban
                                                                </div>
                                                            ):(
                                                                <div>
                                                                    Ujian tidak memiliki soal
                                                                </div>
                                                            )
                                                        }

                                                        <div style={{ display:'none' }} className="card">
                                                            <table className="table table-striped table-bordered animated fadeIn" style={{ display:'none' }} id="table-to-xls3">
                                                                <tbody>
                                                                <tr>
                                                                    <td colSpan="2">Judul</td>
                                                                    <td colSpan="10">{ this.state.dataExport.exam_title }</td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="2">Kelas</td>
                                                                    <td colSpan="10">{ this.state.kelasNama }</td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="2">Mapel</td>
                                                                    <td colSpan="10">{ this.state.dataExport.mapel_nama }</td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="2">Waktu</td>
                                                                    <td colSpan="10">{ this.state.dataExport.exam_start_date } - { this.state.dataExport.exam_end_date } ({ this.state.dataExport.exam_time_limit })</td>
                                                                </tr>
                                                                </tbody>

                                                            </table>
                                                        </div>
                                                    </div>
                                                ) : this.state.dataExportNilai.length === 0 ? (
                                                    <div style={{ textAlign:'center' }}>
                                                        Data Analisa nilai kosong, pastikan anda sudah generate nilai pada halaman sebelumnya
                                                    </div>
                                                ) : (
                                                    <div style={{ display:'none' }} className="card">
                                                        <table className="table table-striped table-bordered animated fadeIn" style={{ display:'none' }} id="table-to-xls3">
                                                            <tbody>
                                                            <tr>
                                                                <td colSpan="2">Judul</td>
                                                                <td colSpan="10">{ this.state.dataExport.exam_title }</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">Kelas</td>
                                                                <td colSpan="10">{ this.state.kelasNama }</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">Mapel</td>
                                                                <td colSpan="10">{ this.state.dataExport.mapel_nama }</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2">Waktu</td>
                                                                <td colSpan="10">{ this.state.dataExport.exam_start_date } - { this.state.dataExport.exam_end_date } ({ this.state.dataExport.exam_time_limit })</td>
                                                            </tr>
                                                            </tbody>
                                                            {
                                                                this.state.dataAnalisa.map((item)=>{

                                                                    return(
                                                                        <tbody>
                                                                        <tr>
                                                                            <th></th>
                                                                            <th>Jawaban</th>
                                                                            <th colSpan={item.sis.length +2}>Analisa</th>
                                                                            <th colSpan={item.opsiC+1}>ANALISA JAWABAN</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Soal</td>
                                                                            <td rowSpan="3">{item.isBenar}</td>
                                                                            <td colSpan={item.sis.length +2}>{item.question_text}</td>
                                                                            {
                                                                                item.aliasN.map(y => {
                                                                                    return <td>{ y }</td>
                                                                                })
                                                                            }
                                                                            <td>Not Answer</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>No. Peserta</td>
                                                                            {
                                                                                item.sis.map((siswa , i)=>{
                                                                                    return(
                                                                                        <td>{i+1}</td>
                                                                                    )
                                                                                })
                                                                            }
                                                                            <td>BENAR</td>
                                                                            <td>{item.ben}</td>
                                                                            {
                                                                                item.aliasN.map(y => {
                                                                                    return <td>{ item.gr[y] ? item.gr[y] : '0'} </td>
                                                                                })
                                                                            }
                                                                            <td>{item.gr['Not Answer'] ? item.gr['Not Answer'] :'0'}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Jawaban</td>
                                                                            {
                                                                                item.sis.map((siswa , i)=>{
                                                                                    return(
                                                                                        <td>{siswa.jwb}</td>
                                                                                    )
                                                                                })
                                                                            }
                                                                            <td>SALAH</td>
                                                                            <td>{item.sal}</td>
                                                                            {
                                                                                item.aliasN.map(y => {
                                                                                    return <td>{ item.gr[y] ? (item.gr[y]/item.sis.length)*100 : '0'} [%]</td>
                                                                                })
                                                                            }
                                                                            <td>{item.gr['Not Answer'] ? (item.gr['Not Answer']/item.sis.length)*100 : '0'} [%]</td>
                                                                        </tr>
                                                                        </tbody>
                                                                    )
                                                                })
                                                            }
                                                        </table>
                                                    </div>
                                                )
                                            }
                                            <div style={{ textAlign:'center' }}>
                                                {
                                                    this.state.dataAnalisa.length > 0 ? (
                                                        <div>
                                                            Report Excel siap di Unduh, Klik tombol bawah untuk unduh laporan
                                                            <br/>
                                                            <i className="fa fa-download"></i>
                                                            <br/>
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={this.exportFile}>
                                                                {"Download File"}
                                                            </button>
                                                        </div>
                                                    ): (
                                                        <div>
                                                            Report Excel siap di Unduh, <b>TANPA ANALISA JAWABAN</b>, Klik tombol bawah untuk unduh laporan
                                                            <br/>
                                                            <i className="fa fa-download"></i>
                                                            <br/>
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={this.exportFile}>
                                                                {"Download File"}
                                                            </button>
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        );
    }
}

export default ScoreExport;



// WEBPACK FOOTER //
// ./src/views/Exam/Report/ScoreExport.js